import { provideStates } from '@ngxs/store';
import { ClientIntakeFormContextState } from './state/clientIntakeFormContext.firebase.state';

export const PROVIDE_CLIENT_INTAKE_FORM_CONTEXT_STATE = [
	provideStates([ClientIntakeFormContextState]),
];
